import { render, staticRenderFns } from "./TheArchMonumentIcon.vue?vue&type=template&id=f2f5657c&"
import script from "./TheArchMonumentIcon.vue?vue&type=script&lang=js&"
export * from "./TheArchMonumentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports